import React from 'react';
import { Preloader, Oval } from 'react-preloader-icon';
import { Box } from '@material-ui/core';

const Loader = ({ size = 50, p = 7 }) => {
    return (
        <Box p={p}>
            <Preloader use={Oval} size={size} strokeWidth={8} strokeColor="#cc0514" duration={800} style={{ margin: '0 auto' }} />
        </Box>
    );
};

export default Loader;
